import { FormLabel, Grid, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  
    handleInputChange,
    index,
    row,
    viewMode,
    validationStatus,
}) => {
    //inline style
    const InlineStyle = {
        EntityDivison: {
            width: "230px", height: "32", padding: "0px"
        },
    }
    return (
      <form>
        <Grid container justifyContent={"space-between"}>
          <Grid
            item
            xs={3}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Binding Agreement Type</FormLabel>
            <TextField
              value={row.binding_aggrement_type}
              onChange={(e) =>
                handleInputChange(index, "binding_aggrement_type", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.binding_aggrement_type && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.binding_aggrement_type}
              </span>
            )}
          </Grid>
      
        </Grid>
      </form>
    );
}